module.exports = __webpack_public_path__ + "img/full-screen-exit.fb88bd40.svg";